import { LocaleId, TranslationDictionaryMapping } from '@i18n';
import { OverlayTranslationDictionary } from './overlay-translation-dictionary.interface';

export const translation: TranslationDictionaryMapping<OverlayTranslationDictionary> =
  {
    [LocaleId.English_GreatBritain]: {
      OVERLAY_MESSAGE_PROCESSING: 'Processing your details...',
      OVERLAY_MESSAGE_CONTRACT: 'Setting up your contract...',
    },
    [LocaleId.English_Ireland]: {
      OVERLAY_MESSAGE_PROCESSING: 'Processing your details...',
      OVERLAY_MESSAGE_CONTRACT: 'Setting up your contract...',
    },
  };
